import type { ReactNode } from 'react'

import { parseCmsHtml } from '@/utils'

export type TruncateLimits = { mobile: number; tab: number; desktop: number }

const TITLE_LIMITS: TruncateLimits = { mobile: 30, tab: 40, desktop: 60 }
const SUBTITLE_LIMITS: TruncateLimits = { mobile: 40, tab: 100, desktop: 60 }

/**
 * Article-card title truncation, copied verbatim from the ternary the three
 * guide files each repeated.
 *
 * Note the asymmetry, which is current behaviour and deliberately preserved:
 * the mobile and tab branches always append the ellipsis (even for a short
 * title), while the desktop branch only truncates past its limit.
 */
export function truncateTitle(
  title: string,
  isMobile: boolean,
  isTabScreen: boolean,
  limits: TruncateLimits = TITLE_LIMITS
): string {
  if (isMobile) return title?.slice(0, limits.mobile) + '...'
  if (isTabScreen) return title?.slice(0, limits.tab) + '...'
  return title?.length < limits.desktop ? title : title?.slice(0, limits.desktop) + '...'
}

/**
 * Article-card subtitle truncation. Returns parsed CMS HTML, so it is a node
 * rather than a string. Mirrors the original exactly — including that the tab
 * branch does NOT run the text through `parseCmsHtml`.
 */
export function truncateSubtitleHtml(
  html: string,
  isMobile: boolean,
  isTabScreen: boolean,
  limits: TruncateLimits = SUBTITLE_LIMITS
): ReactNode {
  if (isMobile) return parseCmsHtml(html?.slice(0, limits.mobile)) + '...'
  if (isTabScreen) return html?.slice(0, limits.tab) + '...'
  return html?.length < limits.desktop
    ? parseCmsHtml(html)
    : parseCmsHtml(html?.slice(0, limits.desktop)) + '...'
}
